import { render, staticRenderFns } from "@/style-guide/partials/button-switch/button-switch.pug?vue&type=template&id=78051b58&scoped=true&lang=pug&external"
import script from "./button-switch.vue?vue&type=script&lang=ts"
export * from "./button-switch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78051b58",
  null
  
)

export default component.exports